import React, { ReactNode } from 'react';
import './MenuItem.css';
import withTheme from '../../../hocs/withTheme';

function MenuItem({
    children = null, onClick = () => {},...rest
}: {children?: ReactNode, onClick?: () => void}) {
    return (
        <li
            {...rest}
            className="menu-item"
            role="menuitem"
            onClick={onClick}
        >
            {children}
        </li>
    );
}

export default withTheme(MenuItem);
